import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <div className={`flex items-center gap-4 ${className}`}>
    <span className="gold-line" />
    <span className="eyebrow">{children}</span>
  </div>
);

export const Button = ({ children, variant = "solid", as: As = "button", className = "", ...props }) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium tracking-wide transition-all duration-300 will-change-transform";
  const styles = {
    solid: "bg-ink text-cream hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/10",
    outline: "border border-gold text-ink hover:bg-gold hover:text-white hover:-translate-y-0.5",
    ghost: "text-ink hover:opacity-60",
  };
  return (
    <As className={`${base} ${styles[variant]} ${className}`} {...props}>
      {children}
    </As>
  );
};
